export default __webpack_public_path__ + "Xero_WizardBooks_INV-1234.csv";